//
//
//
//
//
//
//
//
//

export default {
  props: ['market', 'event', 'outcome', 'label'],
  data() {
    return {
      lastUpdate: +new Date(),
      currentTime: +new Date(),
      showMovement: false,
      disabled: false,
      loading: true,
      movement: 0,
      balance: null
    }
  },
  computed: {
      selected() {
        if(_.get(this.$store, 'state.betslipType') != 'betbuilder')
          return false;
        return _.get(this.event, 'hash') == this.$store.state.betbuilder.precannedId
      },
      processingStatus: {
        get() {
          return this.$store.state.betbuilder.processingStatus
        },
        set(value) {
          this.$store.commit('betbuilder/setProcessingStatus', value)
        }
      }
  },
  filters: {
    format_odds(value, oddsFormat) {
      return _.get(value, 'display_odds.' + oddsFormat, parseFloat(value.odds).toFixed(2))
    }
  },
  watch: {},

  mounted() {},
  methods: {
    addToSlip(event) {
      this.$store.commit('setBetSlipType', 'betbuilder');
      this.$store.commit('betbuilder/setPrecannedLoading', true);
      this.$store.commit('betslip/toggleBetslip', true);
      this.$root.$emit('show_betslip');

      const isSelected = this.selected;

      console.log('outcome event', event);
      this.$store.commit('betbuilder/clear');
      this.$store.commit('betbuilder/setEvent', _.get(event, 'id'));
      this.$store.commit('betbuilder/setPrecannedId', _.get(event, 'hash'));

      for (let outcome of _.get(event, 'selections', [])) {
        console.log('outcome selection', outcome);
        this.$store.commit('betbuilder/add', outcome);
      }

      if (isSelected) {
        this.$store.commit('betbuilder/setPrecannedId', null);
        this.$store.commit('betbuilder/clear');
      } else {
        this.$store.commit('betbuilder/setPrecannedId', _.get(event, 'hash'));
      }

      setTimeout(() => {
        this.$root.$emit('betbuilder_added');
      }, 1);
    }
  }
}
